import { render, staticRenderFns } from "./StripePaymentMethod.vue?vue&type=template&id=36edd3ca&"
import script from "./StripePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./StripePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./StripePaymentMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports